import _ from 'lodash'
var OFD_ORIGIN = 'http://anyloader.com'
var API_BASEURL = `${OFD_ORIGIN}/api/v1`

export const useFansly = () => {
	const {useExtension, removeKeys, getCookies, extFetch, parseUrl} = useHelpers()

    async function api (method, path, options) {
		let {result: fanslyAuth} = await useExtension('fansly.getAuthToken', [], 'bg')
		if (options?.qs) {
			path += '?' + new URLSearchParams(removeKeys(options.qs, (key, value) => !value))
			delete options.qs
		}
		const url = `https://apiv3.fansly.com/api/v1${path}`
		console.log(`[useFansly] API Request: ${method} ${url}`, {hasToken: !!fanslyAuth?.token});
		
		const headers = {
			"accept": "application/json, text/plain, */*",
			"authorization": fanslyAuth?.token,
		}

		if (fanslyAuth?.sessionId) headers['fansly-session-id'] = fanslyAuth.sessionId;
		if (fanslyAuth?.clientId) headers['fansly-client-id'] = fanslyAuth.clientId;
		
		// Add timestamp-based headers
		const ts = Date.now().toString();
		headers['fansly-client-ts'] = ts;
		// Simple version of client-check, might need adjustment if Fansly rejects it
		headers['fansly-client-check'] = Math.random().toString(16).substring(2, 15);

		let {body} = await extFetch(url, {
			method,
			headers,
			...options
		})
        return body
	}

	async function getMe () {
		const data = await api('GET', '/account/me')
		console.log('[useFansly] getMe response:', data);
		const account = data.response?.account
		if (account) {
			const me = _.pick(account, ['id', 'email', 'username', 'displayName'])
			me.name = me.displayName || me.username
			return me
		}
		return {}
	}

	async function getUser (url) {
		let {username} = parseUrl(url)
		const data = await api('GET', `/account?usernames=${username}`)
		return data.response?.[0] || {}
	}
	

	async function getCreatorId (username) {
		const data = await api('GET', `/account?usernames=${username}`)
		return data.response[0].id
	}
	
	function parseMediaInfo({access, media}) {
		if (!media) return null;

		let locations = [];
		
		// 1. Collect primary locations (usually the original/best quality)
		if (media.locations && media.locations.length > 0) {
			media.locations.forEach(l => locations.push({ ...l, isPrimary: true }));
		}

		// 2. Collect variant locations (transcoded or resized versions)
		if (media.variants) {
			media.variants.forEach(v => {
				if (v.locations) {
					v.locations.forEach(l => {
						locations.push({
							...l,
							variantType: v.type, // Store type to detect previews
							width: v.width,
							height: v.height
						});
					});
				}
			});
		}

		if (locations.length > 0) {
			// Scoring system to pick the absolute best media
			const getScore = (loc) => {
				let score = loc.quality || parseInt(loc.locationId) || 0;
				
				// Boost based on resolution (Width * Height)
				if (loc.width && loc.height) {
					score += (loc.width * loc.height) / 1000;
				}

				// High Priority: Primary/Original locations
				if (loc.isPrimary) score += 1000000;

				// Video format priorities
				if (loc.location?.includes('.mp4')) score += 20000;
				if (loc.location?.includes('.m3u8')) score += 10000;

				// Image variant types:
				// Type 1 is usually the main image, Type 2 is usually video
				if (loc.variantType === 1 || loc.variantType === 2) score += 50000;
				
				// AVOID: Type 3 is usually blurred, Type 4 is usually tiny thumbnail
				if (loc.variantType === 3) score -= 200000; 
				if (loc.variantType === 4) score -= 300000;

				return score;
			};

			const bestLocation = locations.reduce((prev, current) => {
				return (getScore(prev) > getScore(current)) ? prev : current;
			});

			let url = bestLocation.location;
			if (bestLocation.metadata && typeof bestLocation.metadata === 'object') {
				const params = new URLSearchParams(bestLocation.metadata).toString();
				if (params) {
					url += (url.includes('?') ? '&' : '?') + params;
				}
			}

			// Determine type and extension
			let type = 'image', extension = 'bin';
			const lowUrl = url.toLowerCase();
			if (lowUrl.includes('.mp4')) { type = 'video'; extension = 'mp4'; }
			else if (lowUrl.includes('.m3u8')) { type = 'video'; extension = 'm3u8'; }
			else if (lowUrl.includes('.mpd')) { type = 'video'; extension = 'mpd'; }
			else if (lowUrl.includes('.jpeg') || lowUrl.includes('.jpg')) { type = 'image'; extension = 'jpg'; }
			else if (lowUrl.includes('.png')) { type = 'image'; extension = 'png'; }
			else if (lowUrl.includes('.gif')) { type = 'image'; extension = 'gif'; }
			else {
				const [mimeType, mimeExt] = (media.mimetype || '').split('/');
				type = mimeType === 'video' ? 'video' : 'image';
				extension = mimeExt || 'bin';
				if (extension.includes('mpegurl')) { extension = 'm3u8'; type = 'video'; }
				else if (extension.includes('dash+xml')) { extension = 'mpd'; type = 'video'; }
			}

			let mediaMetadata = {}
			try {
				mediaMetadata = typeof media.metadata === 'string' ? JSON.parse(media.metadata) : (media.metadata || {})
			} catch (e) {}

			const parsedMedia = {
				id: media.id,
				type: type,
				duration: mediaMetadata?.duration,
				canView: access,
				thumbnail: (type === 'image' || (extension !== 'm3u8' && extension !== 'mpd' && extension !== 'mp4')) ? url : '',
				url: url,
				previewUrl: url,
				createdAt: media.createdAt,
				fileName: `${media.id}.${extension}`,
				website: 'fansly.com',
				hls: extension === 'm3u8',
				dash: extension === 'mpd'
			};
			
			console.log('[useFansly] Parsed media result:', parsedMedia);
			return parsedMedia;
		}
		return null;
	}
	
	async function getSinglePostDownloadUrls(postId) {
		console.log('[useFansly] Fetching single post:', postId);
		const data = await api('GET', `/post?ids=${postId}&ngsw-bypass=true`)
		console.log('[useFansly] Post API response:', data);
		const mediaObjects = data.response?.accountMedia || []
		const result = mediaObjects.map(parseMediaInfo).filter(Boolean)
		console.log('[useFansly] Parsed post media:', result);
		return result
	}
	
	async function getCollectionsDownloadUrls() {
		const collectionsData = await api('GET', '/account/media/orders/?limit=9999&offset=0&ngsw-bypass=true')
		const accountMediaIds = collectionsData.response.accountMediaOrders.map(order => order.accountMediaId).join(',')
		
		const mediaData = await api('GET', `/account/media?ids=${accountMediaIds}`)
		return mediaData.response.map(parseMediaInfo).filter(Boolean)
	}
	
	async function getMessagesDownloadUrls({chatId, cursor}) {
		const downloadUrls = []
		const params = cursor ? `groupId=${chatId}&before=${cursor}&limit=25&ngsw-bypass=true` : `groupId=${chatId}&limit=25&ngsw-bypass=true`
		console.log('[useFansly] Fetching messages:', {chatId, cursor, params});
		const messagesData = await api('GET', `/message?${params}`)			
		console.log('[useFansly] Messages API response:', messagesData);
		const mediaUrls = (messagesData.response?.accountMedia || []).map(parseMediaInfo).filter(Boolean)
		downloadUrls.push(...mediaUrls)
		if (messagesData.response?.messages?.length > 0) {
			cursor = messagesData.response.messages[messagesData.response.messages.length - 1].id
		}
		return {
			items: downloadUrls,
			cursor
		}
	}
	
	async function getCreatorDownloadUrls({username, creatorId, cursor}) {
		const downloadUrls = []
		if (!creatorId) creatorId = await getCreatorId(username)
		console.log('[useFansly] Fetching creator media:', {username, creatorId, cursor});
		const data = await api('GET', `/timelinenew/${creatorId}?before=${cursor}&after=0&wallId=&contentSearch=&ngsw-bypass=true`)
		console.log('[useFansly] Creator API response:', data);
		const mediaUrls = (data.response?.accountMedia || []).map(parseMediaInfo).filter(Boolean)
		downloadUrls.push(...mediaUrls);
		if (data.response?.posts?.length > 0)
			cursor = data.response.posts[data.response.posts.length - 1].id
		return {
			items: downloadUrls,
			cursor
		}
	}
	
	async function getPosts ({offset}) {
		const data = await api('GET', '/timeline/home', {qs: {offset, limit: 10, mode: 0, 'ngsw-bypass': true}})
		return {
			items: data.response.accountMedia
		}
	}

	return {
		getMedia: async ({form, urlInfo, cursor}) => {
			let {type, chatId, username, postId} = urlInfo
			if (form.source == 'all') {
				let offset = typeof cursor == 'number' ? cursor : 0
				let {items} = await getPosts({offset})
				return {
					items: items.map(parseMediaInfo).filter(Boolean).map(i => ({...i, source: 'all'})),
					cursor: offset + 10
				}
			} else if (type == 'post') {
				let items = await getSinglePostDownloadUrls(postId)
				return {items: items.map(i => ({...i, source: 'post'})), cursor: ''}
			} else if (type == 'user') {
				let result = await getCreatorDownloadUrls({username, cursor})
				return {
					...result,
					items: result.items.map(i => ({...i, source: 'user'}))
				}
			} else if (type == 'chat') {
				let result = await getMessagesDownloadUrls({chatId, cursor})
				return {
					...result,
					items: result.items.map(i => ({...i, source: 'chat'}))
				}
			}
			return {items: [], cursor: ''}
		},
		getMe,
		getUser,
		getPosts,
		getCreatorDownloadUrls,
		getMessagesDownloadUrls,
		getCollectionsDownloadUrls,
		getSinglePostDownloadUrls,
	}
}
